import Swal from 'sweetalert2'
import Cookie from 'js-cookie'
import { userHasPermission, userHasAnyPermission } from '@/helpers/userPermissions'
import { getRoutePermissionRule } from '@/router/routePermissions'

function userMatchesRouteRole(userRoles, routeRole) {
  const rr = String(routeRole || '').toLowerCase()
  if (userRoles.includes(rr)) {
    return true
  }
  if (rr === 'partner' && userRoles.includes('parceiro')) {
    return true
  }
  if (rr === 'parceiro' && userRoles.includes('partner')) {
    return true
  }
  return false
}

export default function authGuard(routeTo, routeFrom, next) {
  const publicPages = ['/login', '/esqueci-senha']
  const isPublicPage = publicPages.includes(routeTo.path)

  let loggedUser = null
  try {
    const raw = localStorage.getItem('user')
    loggedUser = raw ? JSON.parse(raw) : null
  } catch {
    loggedUser = null
  }

  const userRoles = (loggedUser && Array.isArray(loggedUser.roles)
    ? loggedUser.roles
    : []
  ).map((role) => String((role && role.name) || '').toLowerCase())
  const isSuper = userRoles.includes('super')

  const authRequired = routeTo.matched.some(record => record.meta.authRequired)
  const routeRoles = routeTo.meta.roles || []

  // Logout
  if (routeTo.path === '/logout') {
    localStorage.removeItem('user')
    Cookie.remove('_easyindustria_token')
    return next({ name: 'login' })
  }

  // Não logado tentando acessar rota protegida
  if (authRequired && !loggedUser && !isPublicPage) {
    return next({ name: 'login' })
  }

  if (authRequired && routeTo.path !== '/selecionar-empresa' && !localStorage.getItem('currentEmpresa')) {
    return next({ name: 'SelectCompany' })
  }

  // Verifica roles da rota
  if (authRequired && routeRoles.length > 0) {
    const routePermissionRule = getRoutePermissionRule(routeTo)
    if (routePermissionRule) {
      // Alinha com o back-end (Gate::before para role super): super passa em qualquer rota mapeada.
      if (isSuper) {
        return next()
      }

      const hasAnyPermission = routePermissionRule.anyOf
        ? userHasAnyPermission(loggedUser, routePermissionRule.anyOf)
        : true
      const hasAllPermission = routePermissionRule.allOf
        ? routePermissionRule.allOf.every((permissionName) =>
            userHasPermission(loggedUser, permissionName)
          )
        : true
      if (!(hasAnyPermission && hasAllPermission)) {
        return Swal.fire({
          title: 'Acesso negado',
          text: 'Você não tem permissão para acessar esta página.',
          icon: 'error',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false
        }).then(() => next({ name: 'logout' }))
      }
      return next()
    }

    const hasRoleAccess = routeRoles.some((role) =>
      userMatchesRouteRole(userRoles, role)
    )
    // Para a rota home/dashboard, permitir também por permissão granular no backend.
    const hasDashboardPermissionAccess =
      routeTo.name === 'home' && userHasPermission(loggedUser, 'dashboard.view')
    const hasPermission = hasRoleAccess || hasDashboardPermissionAccess

    if (!hasPermission) {
      return Swal.fire({
        title: 'Acesso negado',
        text: 'Você não tem permissão para acessar esta página.',
        icon: 'error',
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => next({ name: 'logout' }))
    }
  }

  return next()
}
